type Sender = 'Owner' | 'Vet'

namespace Message {
  export class Request {
    sender: Sender = 'Owner'
    text = ''
    photo_urls: string[] = []
    video_urls: string[] = []

    constructor(json?: Request) {
      if (json) {
        this.sender = json.sender
        this.text = json.text
        this.photo_urls = json.photo_urls
        this.video_urls = json.video_urls
      }

      return { ...this }
    }
  }

  export class Response extends Request {
    receiver_checked_at: string
    created_at: string

    constructor(json: Response) {
      super(json)
      this.receiver_checked_at = json.receiver_checked_at
      this.created_at = json.created_at

      return { ...this }
    }
  }
}

export default Message
